  import {
    observer,
  } from 'mobx-react';
  import React from 'react';
import Modal from '@material-ui/core/Modal';
import styles from './styles.module.scss';
import Fade from '@material-ui/core/Fade';
import Backdrop from '@material-ui/core/Backdrop';

  interface IProps {
    open: boolean;
    title: string;
    content: JSX.Element;
    handleClose: () => void;
  }
  
  @observer
  class GeneralViewModal extends React.Component<IProps> {

    constructor(props: IProps) {
      super(props);
    }
  
    render() {
      return (
          <div>
            <Modal 
                className={styles.modalContainer}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
                open={this.props.open}
                onClose={this.props.handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
            >
              <div
                  className={styles.modalCard}
              >
                  <h2 id="modal-title">
                      {this.props.title}
                  </h2>
                  {this.props.content}
              </div>
            </Modal>
          </div>
      );
    }
  }
  
  export default GeneralViewModal;
  